// Real quotes from real people, or nothing at all.
//
// ⛔ DO NOT POPULATE THIS FILE WITH EXAMPLES, PLACEHOLDERS OR "representative"
// copy. An invented testimonial is a false advertising claim, and the components
// that read this file render nothing when it is empty, which is the correct
// behaviour until we have the real thing.
//
// Each entry needs:
//   quote  their own words, lightly trimmed at most, never rewritten for us
//   name   first name only
//   role   as they describe themselves
//   town   where they work
//   consent  the date they agreed in writing, and where that agreement is kept
//
// Example of the SHAPE (commented out on purpose):
//   { quote: '…', name: 'Priya', role: 'Dental nurse', town: 'Putney',
//     consent: '2026-10-14, email, support inbox' }

export const WORKER_QUOTES = []

export const WORKPLACE_QUOTES = []
